import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LOADING_STATUS } from '../../../shared/constants/loadingStatus';
import { useApiReady } from '../../../shared/hooks';
import { loadTenantSettings, selectTemplatesTenantSettingsStatus } from '../store/templatesSlice';

export function useTenantSettingsLoader() {
  const dispatch = useDispatch();
  const apiReady = useApiReady();
  const tenantSettingsStatus = useSelector(selectTemplatesTenantSettingsStatus);

  useEffect(() => {
    if (apiReady && tenantSettingsStatus === LOADING_STATUS.IDLE) {
      dispatch(loadTenantSettings());
    }
  }, [apiReady, tenantSettingsStatus, dispatch]);
}
